import { actionCreator } from '@ardoq/rxbeach';

export const setFilterTerm = actionCreator<string>(
  '[viewpointSwitcher] SET_FILTER_TERM'
);
